import { NotifyType } from '../model/user-info.interface';
import { Api } from './api';

export class NotificationsApi {
    private static readonly PATH = '/notifications';

    constructor(private readonly m_api: Api) {}

    public async get() {
        return this.m_api.get(NotificationsApi.PATH);
    }

    public async markNotifyAsRead(notifyId: number, notifyType: NotifyType) {
        return this.m_api.post(`${NotificationsApi.PATH}/mark-as-read`, { notifyId, notifyType });
    }
}